import script from "./MyChartBookTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MyChartBookTable.vue?vue&type=script&setup=true&lang=js"

import "./MyChartBookTable.vue?vue&type=style&index=0&id=4b209cc0&lang=scss"

const __exports__ = script;

export default __exports__